import { Dispatch } from 'redux';
import backend from '../../../apis/backend';
import { ReduxState } from '../../state';
import { 
  getOtherItemsFromBusinessSuccess,
  getOtherItemsFromBusinessFailure
} from '../actions';

// Action to fetch business items for a specific business
export const fetchOtherItemsFromBusiness = (businessId: string, more: boolean = false) => {
  return async (dispatch: Dispatch, getState: () => ReduxState) => {
    try {
      // Get the loginToken from the Redux state
      const { auth } = getState();
      const loginToken = auth.loginToken;
      let fetchedBusinessItems: any[] = [];
      // Construct the headers with X-Auth-Token
      const headers = {
        'X-Auth-Token': loginToken,
      };
      // Construct the URL with query parameters
      let url = `/marketplace-service/api/v1/items?businessId=${businessId}&sortBy=updatedAt&sortDirection=desc&describe=1`
      const response = await backend.get(url, { headers });

      if (response.status === 200) {
        fetchedBusinessItems = response.data.items;
        dispatch(getOtherItemsFromBusinessSuccess(fetchedBusinessItems));
      } else {
        dispatch(getOtherItemsFromBusinessFailure('Failed to fetch business items.'));
      }
    } catch (error) {
      console.error('Error fetching business items:', error);
      dispatch(getOtherItemsFromBusinessFailure('An error occurred while fetching business items.'));
    }
  };
};